import { api } from "@/api/client";

export const USUARIO_PATH = "instituicao/Usuario";

export interface Usuario {
  id: number;
  nome: string;
  email: string;
  usuario: string;
  tipoUsuario?: string;
}

export interface UsuarioFiltro {
  tipoUsuarioIn: string[];
  nome?: string;
  email?: string;
}

export async function getUsuario(id: number): Promise<Usuario> {
  const { data } = await api.get<Usuario>(`${USUARIO_PATH}/${id}`);
  return data;
}

// Legado sempre POST tanto pra criar quanto editar (backend decide pelo id no
// corpo) — app/controllers/form-usuario.controller.js.
export async function saveUsuario(registro: Record<string, unknown>): Promise<Usuario> {
  const { data } = await api.post<Usuario>(USUARIO_PATH, registro);
  return data;
}

export async function deleteUsuario(id: number): Promise<void> {
  await api.delete(`${USUARIO_PATH}/${id}`);
}
